import PricingTool from "../../features/pricing-tool/PricingTool";

export default function PricingToolPage() {
  return <PricingTool />;
}
